




















import { State, Getter, Action } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { SortOrder } from '@/enums/SortOrder';
import { Debounce } from '@/functions/debounce';
import { Searchable } from '@/mixins/searchable';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    TableBase: () => import('@/components/table/base.vue'),
    IndexSearch: () => import('@/components/parts/IndexSearch.vue'),
  },
})
export default class PageDieselTaxTranslations extends Searchable<DieselTax> {
  @Getter('workspace/selected') workspace!: Workspace;

  @Getter('diesel-tax/all') dieselTaxes!: DieselTax[];

  @Action('diesel-tax/index') indexDieselTaxs!: ({ query, workspaceId }: { query?: IndexQuery<DieselTax>; workspaceId: number }) => Promise<{ total: number; data: DieselTax[] }>;

  i18n: string = 'views.diesel-taxes.index';

  searchItemsProperty = 'dieselTaxes';

  defaultSortQuery = { country: SortOrder.ASC, id: SortOrder.ASC };

  tableLayout = {
    settings: {
      locale_path: `${this.i18n}.table`,
      max_height: 'calc(100% - 136px)',
      clickable: true,
    },
    structure: [
      {
        key: 'country',
      },
      {
        key: 'percentage',
      },
    ],
  };

  get defaultSearchQuery(): Query<DieselTax> {
    return { or: { country: [`like:*${this.searchText}*`, `match:${this.searchText}`] } };
  }

  @Debounce(500)
  handleSearch(searchText: string) {
    this.searchText = searchText;
    this.indexDieselTaxs({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  handleSort(item: any) {
    this.sorting = item;
    this.indexDieselTaxs({ query: { q: this.searchQuery, per_page: 20, s: this.sortQuery }, workspaceId: this.workspace.id });
  }

  loadMore() {
    this.indexDieselTaxs({ query: { q: this.searchQuery, after: this.lastAfter, s: this.sortQuery }, workspaceId: this.workspace.id });
  }
}
